export const jidsConsumableSupply = [
  'California',
  'Colorado',
  'Connecticut',
  'Florida',
  'Georgia',
  'Indiana',
  'Kentucky',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'New Jersey',
  'New York',
  'North Carolina',
  'South Carolina',
  'Tennessee',
  'Washington',
  'Wisconsin',
];

export const consumableSupply_unit = [
  '¼ unit left',
  '½ unit left',
  '¾ unit left',
  '1 unit left',
  '1 & ¼ units left',
  '1 & ½ units left',
  '1 & ¾ units left',
  '2 units left',
  '2 & ¼ units left',
  '2 & ½ units or more left',
  'Out of Stock',
];

export const consumableSupply_pack = [
  '¼ pack left',
  '½ pack left',
  '¾ pack left',
  '1 pack left',
  '1 & ¼ packs left',
  '1 & ½ packs left',
  '1 & ¾ packs left',
  '2 packs left',
  '2 & ¼ packs left',
  '2 & ½ packs or more left',
  'Out of Stock',
];

export const consumableSupply_rolls = [
  '¼ roll left',
  '½ roll left',
  '¾ roll left',
  '1 roll left',
  '1 & ¼ rolls left',
  '1 & ½ rolls left',
  '1 & ¾ rolls left',
  '2 rolls left',
  '2 & ¼ rolls left',
  '2 & ½ rolls or more left',
  'Out of Stock',
];
